// PasswordInputControlView.
import eventBus         from 'EventBus';
import BaseControlView from 'BaseControlView';
import constants        from "Constants";
import template from 'advanced-inputs/control_password_input.ejs';

//=====================================================================
//
// An instance of this view represents a password input control.
//
// Maty Rocha, February, 15 2016
//
//=====================================================================
class PasswordInputControlView extends BaseControlView  {

    initialize( opts ) {
        super.initialize( opts );

        this.template = template;
        this.tagName = 'div';
        this.family = constants.CONTROL_ADVANCED_INPUTS;
        this.icon = 'pf-password-text-input';

        this.listenTo( eventBus, 'InputThemeChange', this.themeChangeRender );
        this.listenTo( eventBus, constants.EV_UPDATE_MARGIN_FROM_FORM, this.mobileMarginChangeRender);
        return this;
    }

    // Neighbor aligner uses this polymorphic property, looking for
    // value 'BaseStaticTextControl'
    get kind() {
        return 'BaseStaticTextControl';
    }


}

export default PasswordInputControlView;
